export const ru = {
    'approx-price-lower-boundary-label': 'от {approxPrice}',
    'info-line': 'Стоимость и сроки примерные, указаны по данным специалиста'
};
